export const always = () => true;

/** handy type guard for errors */
export const isErr = (e: unknown): e is Error => e instanceof Error;

/** e should always be an error, but if it isn't, make do: */
export const errToStr = (e: unknown) => (isErr(e) ? e.message : "err: " + e);
